__turbopack_context__.v({
  "actionButton": "ProductGallery-module-scss-module__6sx6vW__actionButton",
  "actionButtonActive": "ProductGallery-module-scss-module__6sx6vW__actionButtonActive",
  "actionsWrapper": "ProductGallery-module-scss-module__6sx6vW__actionsWrapper",
  "badge": "ProductGallery-module-scss-module__6sx6vW__badge",
  "gallery": "ProductGallery-module-scss-module__6sx6vW__gallery",
  "gallery-spin": "ProductGallery-module-scss-module__6sx6vW__gallery-spin",
  "galleryIcons": "ProductGallery-module-scss-module__6sx6vW__galleryIcons",
  "image": "ProductGallery-module-scss-module__6sx6vW__image",
  "imageLink": "ProductGallery-module-scss-module__6sx6vW__imageLink",
  "imageLoaded": "ProductGallery-module-scss-module__6sx6vW__imageLoaded",
  "imageLoading": "ProductGallery-module-scss-module__6sx6vW__imageLoading",
  "imageSpinner": "ProductGallery-module-scss-module__6sx6vW__imageSpinner",
  "labelSlot": "ProductGallery-module-scss-module__6sx6vW__labelSlot",
  "navButton": "ProductGallery-module-scss-module__6sx6vW__navButton",
  "navNext": "ProductGallery-module-scss-module__6sx6vW__navNext",
  "navPrev": "ProductGallery-module-scss-module__6sx6vW__navPrev",
  "slide": "ProductGallery-module-scss-module__6sx6vW__slide",
  "swiper": "ProductGallery-module-scss-module__6sx6vW__swiper",
  "swiperContainer": "ProductGallery-module-scss-module__6sx6vW__swiperContainer",
});
